import { render, staticRenderFns } from "./commonTermSetting.vue?vue&type=template&id=237623fa&scoped=true"
import script from "./commonTermSetting.vue?vue&type=script&lang=js"
export * from "./commonTermSetting.vue?vue&type=script&lang=js"
import style0 from "./commonTermSetting.vue?vue&type=style&index=0&id=237623fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237623fa",
  null
  
)

export default component.exports